module.exports = __webpack_public_path__ + "media/images/flags/4x3/cog-384e7dae4ad9ad0647ef13c8b9570fd9.svg";